<template>
  <div class="colors">{{ colors }}</div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Colors",

  data() {
    return {
      colors: []
    };
  },
  mounted: function() {
    var self = this;
    const colorsRef = firebase
      .firestore()
      .collection("colors")
      .doc("0");
    colorsRef
      .get()
      .then(function(doc) {
        if (doc.exists) {
          let c = doc.data();
          for (const i of c["knotty-colors"]) {
            i.show = true;
          }
          const knottyColors = c["knotty-colors"];
          self.colors = knottyColors;
          setTimeout(() => {
            self.changed = false;
          }, 500);
        } else {
          // doc.data() will be undefined in this case
          console.warn("No such document!");
        }
      })
      .catch(function(error) {
        console.error("Error getting document:", error);
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Colors.vue